import { render, staticRenderFns } from "./LoanBulkUpload.vue?vue&type=template&id=2a4ef704&scoped=true"
import script from "./LoanBulkUpload.vue?vue&type=script&lang=js"
export * from "./LoanBulkUpload.vue?vue&type=script&lang=js"
import style0 from "./LoanBulkUpload.vue?vue&type=style&index=0&id=2a4ef704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ef704",
  null
  
)

export default component.exports